var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsActivityLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 12.5333V10.6667H11.6667V12.8L13.1 14.2333L13.5667 13.7667L12.3333 12.5333ZM8 2.66666L4.05 4.95L8 7.23333L11.95 4.95L8 2.66666ZM2 10.65V5.35C2 5.10555 2.05833 4.88333 2.175 4.68333C2.29167 4.48333 2.45556 4.32222 2.66667 4.2L7.33333 1.51666C7.44444 1.46111 7.55278 1.41666 7.65833 1.38333C7.76389 1.34999 7.87778 1.33333 8 1.33333C8.12222 1.33333 8.23889 1.34999 8.35 1.38333C8.46111 1.41666 8.56667 1.46111 8.66667 1.51666L13.3333 4.2C13.5444 4.32222 13.7083 4.48333 13.825 4.68333C13.9417 4.88333 14 5.10555 14 5.35V8H12.6667V6.06666L7.98333 8.76666L3.33333 6.06666V10.6333L7.33333 12.95V14.4833L2.66667 11.8C2.45556 11.6778 2.29167 11.5167 2.175 11.3167C2.05833 11.1167 2 10.8944 2 10.65ZM9.64167 15.025C8.99167 14.375 8.66667 13.5889 8.66667 12.6667C8.66667 11.7444 8.99167 10.9583 9.64167 10.3083C10.2917 9.65833 11.0778 9.33333 12 9.33333C12.9222 9.33333 13.7083 9.65833 14.3583 10.3083C15.0083 10.9583 15.3333 11.7444 15.3333 12.6667C15.3333 13.5889 15.0083 14.375 14.3583 15.025C13.7083 15.675 12.9222 16 12 16C11.0778 16 10.2917 15.675 9.64167 15.025Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsActivityLog);
export default __webpack_public_path__ + "static/media/icons-activity-log.f7eceb84.svg";
export { ForwardRef as ReactComponent };